module.exports = __webpack_public_path__ + "9a67b98dc087b57d090c0b506a276c99.svg";